import columns from '../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    DateTimeColumn,
    ExternalConsignmentLinkColumn,
    MultilineColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new ExternalConsignmentLinkColumn(new TextColumn('Consignment ID', 'consignmentId')),
        new DateTimeColumn('Completion date', 'completionDate'),
        new TextColumn('CARDIT EDI file name', 'carditEdiFileName'),
        new TextColumn('CARDIT flat file name', 'carditFlatFileName'),
        new MultilineColumn('RESDIT EDI file name', 'resditEdiFileNames'),
        new MultilineColumn('RESDIT flat file name', 'resditFlatFileNames'),
      ],
    },
  ];
};
